import brandingConfig from '@/app/config/branding'
import travelFilterConfig from '@/app/config/travelFilter'
import googleMapConfig from '@/app/config/googleMap'
import bookingConfig from '@/app/config/booking'
import featuresConfig from '@/app/config/features'
import maintenanceConfig from '@/app/config/maintenance'

let appConfig = {
  ...maintenanceConfig,
  ...featuresConfig,
  ...brandingConfig,
  ...travelFilterConfig,
  ...googleMapConfig,
  ...bookingConfig,
}
export default appConfig
